/** @format */
import isPropValid from '@emotion/is-prop-valid';
import React, { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';

import { styles } from './row.styles';

/**
 * At what point the rows should stack on each other
 */
// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum RowStackVariant {
    DESKTOP = 'DESKTOP',
    LARGE_TABLET = 'LARGE_TABLET',
    SMALL_TABLET = 'SMALL_TABLET',
    MOBILE = 'MOBILE',
    SMALL_MOBILE = 'SMALL_MOBILE',
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
export interface RowProps {
    /**
     * Child elements
     */
    children?: ReactNode | ReactNode[];

    /**
     * Selection ID for test purposes.
     */
    'data-testid'?: string;

    /**
     * Custom className
     */
    className?: string;

    /**
     * At what point the columns should stack on each other
     *
     * @default RowStackVariant.SMALL_TABLET
     */
    stackVariant?: RowStackVariant;

    /**
     * Gap between columns when stacked
     */
    stackGap?: string;
}

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type RowStyleProps = RowProps & { columns: ReactNode[] };

const StyledRow = styled('div').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const Row: FunctionComponent<RowProps> = ({
    children,
    stackVariant = RowStackVariant.SMALL_TABLET,
    ...otherProps
}: RowProps) => {
    let columns: ReactNode[];

    // Makes sure columns is an array of React Nodes
    if (!Array.isArray(children)) {
        if (!children) {
            columns = [];
        } else {
            columns = [children];
        }
    } else {
        columns = children;
    }

    return (
        <StyledRow
            {...otherProps}
            stackVariant={stackVariant}
            columns={columns}
        >
            {children}
        </StyledRow>
    );
};
